import { parse } from "tldts";

import {
  landingPageData,
  landingPageData_qa,
  landingPageData_development,
} from "../Data/landingPageData";


const localisations = {
  landingPageData,
  landingPageData_qa,
  landingPageData_development
}

const getRootDomain = (url) => {
  const result = parse(url);
  return result.domain ?? result.hostname;
};

// note this is a little hacky for now but works for our needs
export default function useLocalisation() {
  const env = getEnvFromHostname(window.location.hostname);
  const domain = getRootDomain(window.location.hostname)
  return {
      landingPageData: mergeLocalisationData("landingPageData", domain, env)
  };
}

function mergeLocalisationData(key, domain, environment) {
  let baseData = localisations[key][domain] || localisations[key]["default"]
  if(environment !== "production") {
    return deepMerge(
      baseData,
      localisations[`${key}_${environment}`][domain] || localisations[`${key}_${environment}`]["default"] || {});
  }
  return baseData;
}

function deepMerge(target, source) {
  for (const key in source) {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      target[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      target[key] = source[key];
    }
  }
  return target;
}

function getEnvFromHostname(hostname) {
  const subdomain = hostname.toLowerCase();
  if(
    subdomain.includes("localhost") ||
    subdomain.includes("development")) {
    return "development";
  }
  if(
    subdomain.includes("qa") ||
    subdomain.includes("qaext")) {
    return "qa";
  }
  return "production";
}